import { createGlobalState } from 'react-use';

export enum EView {
  LIST = 'LIST',
  TABLE = 'TABLE',
}

export const useToggleViewButtons = createGlobalState<EView>(EView.LIST);
